export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-mascot.vue?vue&type=template&id=fb6e435c"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-mascot.vue?vue&type=template&id=fb6e435c
// module id = jLBU
// module chunks = 0